var $9a3f292371bb0589$exports = {};
$9a3f292371bb0589$exports = {
  "alpha": "\u05D0\u05DC\u05E4\u05D0",
  "black": "\u05E9\u05D7\u05D5\u05E8",
  "blue": "\u05DB\u05D7\u05D5\u05DC",
  "blue purple": "\u05DB\u05D7\u05D5\u05DC \u05E1\u05D2\u05D5\u05DC",
  "brightness": "\u05D1\u05D4\u05D9\u05E8\u05D5\u05EA",
  "brown": "\u05D7\u05D5\u05DD",
  "brown yellow": "\u05D7\u05D5\u05DD \u05E6\u05D4\u05D5\u05D1",
  "colorName": function colorName(args) {
    return "".concat(args.lightness, " ").concat(args.chroma, " ").concat(args.hue);
  },
  "cyan": "\u05D8\u05D5\u05E8\u05E7\u05D9\u05D6",
  "cyan blue": "\u05DB\u05D7\u05D5\u05DC \u05E6\u05D9\u05D0\u05DF",
  "dark": "\u05DB\u05D4\u05D4",
  "gray": "\u05D0\u05E4\u05D5\u05E8",
  "grayish": "\u05D0\u05E4\u05E8\u05E4\u05E8",
  "green": "\u05D9\u05E8\u05D5\u05E7",
  "green cyan": "\u05E6\u05D9\u05D0\u05DF \u05D9\u05E8\u05D5\u05E7",
  "hue": "\u05D2\u05D5\u05D5\u05DF",
  "light": "\u05D0\u05D5\u05E8",
  "lightness": "\u05DB\u05DE\u05D5\u05EA \u05D0\u05D5\u05E8",
  "magenta": "\u05DE\u05D2'\u05E0\u05D8\u05D4",
  "magenta pink": "\u05D5\u05E8\u05D5\u05D3 \u05DE\u05D2'\u05E0\u05D8\u05D4",
  "orange": "\u05DB\u05EA\u05D5\u05DD",
  "orange yellow": "\u05DB\u05EA\u05D5\u05DD \u05E6\u05D4\u05D5\u05D1",
  "pale": "\u05D7\u05D9\u05D5\u05D5\u05E8",
  "pink": "\u05D5\u05E8\u05D5\u05D3",
  "pink red": "\u05D5\u05E8\u05D5\u05D3 \u05D0\u05D3\u05D5\u05DD",
  "purple": "\u05E1\u05D2\u05D5\u05DC",
  "purple magenta": "\u05DE\u05D2'\u05E0\u05D8\u05D4 \u05E1\u05D2\u05D5\u05DC",
  "red": "\u05D0\u05D3\u05D5\u05DD",
  "red orange": "\u05DB\u05EA\u05D5\u05DD \u05D0\u05D3\u05D5\u05DD",
  "saturation": "\u05E8\u05D5\u05D5\u05D9\u05D4",
  "transparentColorName": function transparentColorName(args) {
    return "".concat(args.lightness, " ").concat(args.chroma, " ").concat(args.hue, ", ").concat(args.percentTransparent, " \u05E9\u05E7\u05D5\u05E3");
  },
  "very dark": "\u05DB\u05D4\u05D4 \u05DE\u05D0\u05D5\u05D3",
  "very light": "\u05D1\u05D4\u05D9\u05E8 \u05DE\u05D0\u05D5\u05D3",
  "vibrant": "\u05EA\u05D5\u05E1\u05E1",
  "white": "\u05DC\u05D1\u05DF",
  "yellow": "\u05E6\u05D4\u05D5\u05D1",
  "yellow green": "\u05E6\u05D4\u05D5\u05D1 \u05D9\u05E8\u05D5\u05E7"
};
export { $9a3f292371bb0589$exports as default };